export const ocrStartupMessages = {
  'zh-CN': {
    startingEngine: '正在启动识别引擎',
    windowSelectedStage: '游戏窗口已选择',
    timeoutTitle: '识别引擎启动超时',
    timeoutHint: '引擎响应超时，游戏窗口连接仍保留，请尝试重新启动。',
    sdkTimeoutHint: '识别程序加载超时。请重新启动；如果仍然失败，请刷新页面后重新选择窗口。',
    retryEngine: '重新启动',
    copyDiagnostic: '复制诊断信息',
    diagnosticCopied: '诊断信息已复制',
    diagnosticCopyFailed: '自动复制失败，请手动复制下方诊断信息。',
    diagnosticLabel: '启动诊断信息',
    stepWindow: '游戏画面接入',
    stepWindowConnected: '已连接',
    stepWindowConnecting: '连接中...',
    stepWindowSelected: '已选择窗口',
    stepModel: '识别模型载入',
    stepModelReady: '已就绪',
    stepModelLoading: '载入中',
    stepModelChecking: '检查缓存',
    stepEngine: '本地引擎启动',
    stepEngineStarting: '初始化中...',
    stepEngineReady: '已就绪',
  },
  en: {
    startingEngine: 'Starting the recognition engine',
    windowSelectedStage: 'Game window selected',
    timeoutTitle: 'Recognition engine startup timed out',
    timeoutHint: 'The recognition engine timed out. Window connection is retained; please try restarting.',
    sdkTimeoutHint: 'The recognition program took too long to load. Try starting again. If it still fails, reload the page and select your window again.',
    retryEngine: 'Restart',
    copyDiagnostic: 'Copy diagnostics',
    diagnosticCopied: 'Diagnostics copied',
    diagnosticCopyFailed: 'Automatic copying failed. Copy the diagnostics below manually.',
    diagnosticLabel: 'Startup diagnostics',
    stepWindow: 'Game Window',
    stepWindowConnected: 'Connected',
    stepWindowConnecting: 'Connecting...',
    stepWindowSelected: 'Selected',
    stepModel: 'OCR Models',
    stepModelReady: 'Ready',
    stepModelLoading: 'Loading',
    stepModelChecking: 'Checking',
    stepEngine: 'Recognition Engine',
    stepEngineStarting: 'Initializing...',
    stepEngineReady: 'Ready',
  },
}

